# frozen_string_literal: true

module Engine
  module Game
    module GVogel1870
    end
  end
end
